<template>
    <div class="relative flex flex-col overflow-hidden rounded-lg border border-gray-200 bg-white w-full">
        <div class="w-full h-55">
            <div class="skeleton w-full h-full"></div>

            <div class="absolute bottom-0 p-2 w-full flex flex-col bg-gradient-to-t from-black/50 h-1/2 items-start justify-end gap-2">
                <div class="skeleton rounded h-6 w-2/3" style="background-color: #fff;"></div>
                <div class="skeleton rounded h-4 w-1/3" style="background-color: #fff;"></div>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
    name: "GalleryItemLoaderComponent",

    props: [],
})
</script>

<style lang="scss" scoped>

</style>